import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

//******************************************************************************
//  Angular Material Modules
//******************************************************************************
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

//******************************************************************************
//  NPM (Packages) External
//******************************************************************************
import { SDKDatagridModule } from 'sdk-datagrid';
import { SDKLoadingModule } from 'sdk-loading';
import { SDKTabsModule } from 'sdk-tabs';

/** Flat array consumed by standalone component imports[] */
export const EXTERNAL_IMPORTS: any[] = [
    CommonModule,
    FormsModule,
];

const packages = [
    // Angular Material
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule,

    SDKDatagridModule,
    SDKLoadingModule,
    SDKTabsModule,
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ...packages
    ],
    exports: [
        CommonModule,
        FormsModule,
        ...packages
    ],
})

export class ExternalImports { }
